import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialRegioneState } from './regione.state';
import { getRegione } from './regione.utility';
import { GetCittaGQL, GetRegioneGQL } from '../../_graphql/generated';

export const RegioneStore = signalStore(
  { providedIn: 'root' },
  withState(initialRegioneState),
  withProps(() => ({
    getterRegione: inject(GetRegioneGQL),
  })),
  withMethods(({ getterRegione, ...store }, injector = inject(Injector)) => ({
    init: getRegione(injector, store, getterRegione),
  })),
);
